var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 26,
    viewBox: "0 0 14 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.04106 25.475V14.2189H13.0731L13.6768 9.83216H9.04095V7.03143C9.04095 5.76137 9.41728 4.89589 11.361 4.89589L13.8399 4.8948V0.971356C13.4112 0.917993 11.9396 0.798523 10.2277 0.798523C6.65347 0.798523 4.2065 2.8428 4.2065 6.59711V9.83216H0.164116V14.2189H4.2065V25.4749H9.04106V25.475Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.11056aa1ed6d740dc9079ab35c8e82a4.svg";
export { ForwardRef as ReactComponent };